<div class="root">
  <c-page-title>精算履歴の詳細</c-page-title>
  <div class="body">
    <c-payment-table [paymentsArchive$]="paymentArchive$ " />
  </div>
</div>
